/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState } from 'react'
import { Link, useHistory } from 'react-router-dom'
import { AppContext } from '../context/AppContext'
import OrderService from '../services/OrderService'
import { getRequestOptions } from '../helpers/Fetchwrapper'
import clsx from 'clsx'
import Swal from 'sweetalert2'

const OrderCreate = () => {
    const { currentUser } = useContext(AppContext)
    const history = useHistory()
    
    const [loading, setLoading] = useState(false)
    const [submitting, setSubmitting] = useState(false)
    const [addressLoading, setAddressLoading] = useState(false)
    
    // Customer Information
    const [customerSearch, setCustomerSearch] = useState('')
    const [customers, setCustomers] = useState([])
    const [selectedCustomer, setSelectedCustomer] = useState(null)
    


    // Address Information
    const [shippingAddress, setShippingAddress] = useState({
        firstname: '',
        lastname: '',
        company: '',
        house: '',
        street: '',
        block: '',
        area: '',
        region: 'Chittagong',
        postcode: '',
        phone_number: '',
        floor_no: '',
        apartment_no: ''
    })

    // Address Management (similar to checkout.js)
    const [customerAddresses, setCustomerAddresses] = useState([])
    const [showAddressList, setShowAddressList] = useState(false)
    const [selectedAddress, setSelectedAddress] = useState(null)

    const [areas, setAreas] = useState([])

    // Product Information
    const [productSearch, setProductSearch] = useState('')
    const [products, setProducts] = useState([])
    const [selectedProducts, setSelectedProducts] = useState([])
    const [showProductModal, setShowProductModal] = useState(false)

    // Shipping and Payment
    const [shippingMethods, setShippingMethods] = useState([])
    const [selectedShippingMethod, setSelectedShippingMethod] = useState(null)
    const [paymentMethod, setPaymentMethod] = useState('')
    const [comments, setComments] = useState('')
    const [emailSent, setEmailSent] = useState(false)

    // Modal States
    const [showNewCustomerModal, setShowNewCustomerModal] = useState(false)
    const [showNewAddressModal, setShowNewAddressModal] = useState(false)
    
    // New Customer Form
    const [customerForm, setCustomerForm] = useState({
        firstname: '',
        lastname: '',
        email: '',
        mobile_no: '',
        gender: '',
        dob: '',
        password: '',
        is_active: true,
        ispCustomerId: ''
    })

    // New Address Form  
    const [addressForm, setAddressForm] = useState({
        customer_id: '',
        firstname: '',
        lastname: '',
        company: '',
        house: '',
        street: '',
        block: '',
        area: '',
        region: 'Chittagong',
        postcode: '',
        phone_number: '',
        floor_no: '',
        apartment_no: '',
        is_default_shipping: false,
        is_default_billing: false
    })

    useEffect(() => {
        fetchShippingMethods()
    }, [])

    // Auto-search products with debounce
    useEffect(() => {
        const timeoutId = setTimeout(() => {
            if (productSearch && productSearch.length >= 2) {
                searchProducts()
            } else {
                setProducts([])
            }
        }, 300) // 300ms debounce

        return () => clearTimeout(timeoutId)
    }, [productSearch])

    useEffect(() => {
        if (customerSearch) {
            searchCustomers()
        } else {
            setCustomers([])
        }
    }, [customerSearch])

    useEffect(() => {
        const fetchAreas = () => {
            const region = shippingAddress.region || addressForm.region
            if (region) {
                fetch(process.env.REACT_APP_API_URL + `areas/${region}`, getRequestOptions())
                    .then((resp) => resp.json())
                    .then((resp) => {
                        if (resp.success) {
                            const tempArray = resp.data.map((element) => ({
                                label: element.name,
                                value: element.name,
                            }))
                            setAreas(tempArray)
                        }
                    })
                    .catch((error) => console.log("Error fetching areas:", error))
            } else {
                setAreas([])
            }
        }

        fetchAreas()
    }, [shippingAddress.region, addressForm.region])

    const fetchShippingMethods = async () => {
        try {
            const response = await OrderService.getShippingMethods()
            if (response.success) {
                setShippingMethods(response.data || [])
            }
        } catch (error) {
            console.error('Error fetching shipping methods:', error)
        }
    }

    const searchCustomers = async () => {
        try {
            const response = await OrderService.getCustomersList({
                globalSearch: customerSearch,
                limit: 10
            })
            if (response.success) {
                setCustomers(response.data || [])
            }
        } catch (error) {
            console.error('Error searching customers:', error)
        }
    }

    const searchProducts = async () => {
        try {
            const response = await OrderService.getProductsList({
                globalSearch: productSearch,
                limit: 20
            })
            if (response.success) {
                setProducts(response.data || [])
            }
        } catch (error) {
            console.error('Error searching products:', error)
            setProducts([])
        }
    }

    const handleCustomerSelect = async (customer) => {
        setSelectedCustomer(customer)
        setCustomerSearch('')
        setCustomers([])
        setAddressLoading(true)
        
        try {
            // Fetch customer details including addresses
            const response = await fetch(process.env.REACT_APP_API_URL + `customers_details/${customer.customerId}`, getRequestOptions())
            const result = await response.json()
            
            if (result.success && result.data) {
                const customerDetails = result.data
                
                if (customerDetails.addresses && customerDetails.addresses.length > 0) {
                    // Map addresses with proper structure
                    const formattedAddresses = customerDetails.addresses.map(addr => ({
                        ...addr,
                        is_default_shipping: addr.is_default_shipping || false,
                        customerAddressId: addr.customerAddressId || addr.customer_address_id
                    }))
                    
                    setCustomerAddresses(formattedAddresses)
                    
                    // Find default shipping address
                    const defaultAddress = formattedAddresses.find(addr => addr.is_default_shipping)
                    
                    if (defaultAddress) {
                        // Auto-select default address
                        handleAddressSelect(defaultAddress)
                        setShowAddressList(false)
                    } else {
                        // Show address list for selection
                        setShowAddressList(true)
                        setShippingAddress({
                            firstname: customer.firstName || customer.customerName || '',
                            lastname: customer.lastName || 'N/A',
                            company: '',
                            house: '',
                            street: '',
                            block: '',
                            area: '',
                            region: 'Chittagong',
                            postcode: '',
                            phone_number: customer.mobileNo || '',
                            floor_no: '',
                            apartment_no: ''
                        })
                    }
                } else {
                    // No addresses found, clear address list and reset form
                    setCustomerAddresses([])
                    setShowAddressList(false)
                    setShippingAddress({
                        firstname: customer.firstName || customer.customerName || '',
                        lastname: customer.lastName || 'N/A',
                        company: '',
                        house: '',
                        street: '',
                        block: '',
                        area: '',
                        region: 'Chittagong',
                        postcode: '',
                        phone_number: customer.mobileNo || '',
                        floor_no: '',
                        apartment_no: ''
                    })
                }
            } else {
                // API call failed, fallback to basic customer info
                setCustomerAddresses([])
                setShowAddressList(false)
                setShippingAddress({
                    firstname: customer.firstName || '',
                    lastname: customer.lastName || '',
                    company: '',
                    house: '',
                    street: '',
                    block: '',
                    area: '',
                    region: 'Chittagong',
                    postcode: '',
                    phone_number: customer.mobileNo || '',
                    floor_no: '',
                    apartment_no: ''
                })
            }
        } catch (error) {
            console.error('Error fetching customer details:', error)
            // Error fallback to basic customer info
            setCustomerAddresses([])
            setShowAddressList(false)
            setShippingAddress({
                firstname: customer.firstName || customer.customerName || '',
                lastname: customer.lastName || 'N/A',
                company: '',
                house: '',
                street: '',
                block: '',
                area: '',
                region: 'Chittagong',
                postcode: '',
                phone_number: customer.mobileNo || '',
                floor_no: '',
                apartment_no: ''
            })
        } finally {
            setAddressLoading(false)
        }
    }

    const handleAddressSelect = (address) => {
        setSelectedAddress(address)
        setShowAddressList(false)
        
        // Update shipping address form with selected address
        setShippingAddress({
            firstname: address.firstname || address.firstName || selectedCustomer?.firstName || '',
            lastname: address.lastname || address.lastName || selectedCustomer?.lastName || 'N/A',
            company: address.company || '',
            house: address.house || '',
            street: address.street || '',
            block: address.block || '',
            area: address.area || '',
            region: address.region || 'Chittagong',
            postcode: address.postcode || '',
            phone_number: address.phone_number || address.phoneNumber || selectedCustomer?.mobileNo || '',
            floor_no: address.floor_no || address.floorNo || '',
            apartment_no: address.apartment_no || address.apartmentNo || ''
        })
    }

    const changeShowAddressList = () => {
        setShowAddressList(true)
        setSelectedAddress(null)
    }

    const formatAddress = (address) => {
        const parts = []
        
        if (address.house) parts.push(`House ${address.house}`)
        if (address.street) parts.push(`Road ${address.street}`)
        if (address.block) parts.push(`Block ${address.block}`)
        
        const line1 = parts.join(', ')
        
        const line2Parts = []
        if (address.floor_no || address.floorNo) line2Parts.push(`Floor ${address.floor_no || address.floorNo}`)
        if (address.apartment_no || address.apartmentNo) line2Parts.push(`Flat ${address.apartment_no || address.apartmentNo}`)
        
        const line2 = line2Parts.join(', ')
        
        return {
            line1,
            line2,
            area: address.area,
            region: address.region,
            contact: `${address.firstname || address.firstName} | ${address.phone_number || address.phoneNumber}`
        }
    }

    const handleProductSelect = (product) => {
        const existingProduct = selectedProducts.find(p => p.productId === product.product_id)
        
        if (existingProduct) {
            alert('Product already added to the order')
            return
        }

        const newProduct = {
            productId: product.product_id,
            productName: product.product_name,
            sku: product.sku,
            price: product.special_price || product.price,
            regularPrice: product.price,
            specialPrice: product.special_price,
            discountPercent: product.discountPercent || 0,
            orderQty: 1,
            taxPercent: 0,
            type: product.type_id || 'simple',
            availableQty: product.qty || 0
        }

        setSelectedProducts([...selectedProducts, newProduct])
        setShowProductModal(false)
        setProductSearch('')
        setProducts([])
    }

    const updateProductQuantity = (productId, quantity) => {
        setSelectedProducts(products => 
            products.map(product => 
                product.productId === productId 
                    ? { ...product, orderQty: parseInt(quantity) || 1 }
                    : product
            )
        )
    }

    const updateProductPrice = (productId, price) => {
        setSelectedProducts(products => 
            products.map(product => 
                product.productId === productId 
                    ? { ...product, price: parseFloat(price) || 0 }
                    : product
            )
        )
    }

    const removeProduct = (productId) => {
        setSelectedProducts(products => 
            products.filter(product => product.productId !== productId)
        )
    }

    // Customer Form Handlers
    const handleCustomerFormChange = (field, value) => {
        setCustomerForm(prev => ({
            ...prev,
            [field]: value
        }))
    }

    const handleAddressFormChange = (field, value) => {
        setAddressForm(prev => 
            field === "region"
                ? { ...prev, area: "", [field]: value }
                : { ...prev, [field]: value }
        )
    }

    const openNewCustomerModal = () => {
        setCustomerForm({
            firstname: '',
            lastname: '',
            email: '',
            mobile_no: '',
            gender: '',
            dob: '',
            password: '',
            is_active: true,
            ispCustomerId: ''
        })
        setShowNewCustomerModal(true)
    }

    const openNewAddressModal = () => {
        if (!selectedCustomer) {
            alert('Please select a customer first')
            return
        }
        
        setAddressForm({
            customer_id: selectedCustomer.customerId,
            firstname: selectedCustomer.firstName || '',
            lastname: selectedCustomer.lastName || '',
            company: '',
            house: '',
            street: '',
            block: '',
            area: '',
            region: 'Chittagong',
            postcode: '',
            phone_number: selectedCustomer.mobileNo || '',
            floor_no: '',
            apartment_no: '',
            is_default_shipping: false,
            is_default_billing: false
        })
        setShowNewAddressModal(true)
    }

    const submitNewCustomer = async () => {
        try {
            setLoading(true)
            
            const response = await fetch(process.env.REACT_APP_API_URL + 'customers_create', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    ...getRequestOptions().headers
                },
                body: JSON.stringify(customerForm)
            })
            
            const result = await response.json()
            
            if (result.success) {
                Swal.fire({
                    icon: 'success',
                    title: 'Success!',
                    text: 'Customer created successfully!',
                    confirmButtonColor: '#3085d6',
                    timer: 2000,
                    showConfirmButton: false
                })
                
                // Auto-select the new customer
                const newCustomer = {
                    customerId: result.data.id,
                    customerName: result.data.firstname,
                    firstName: result.data.firstname,
                    lastName: result.data.lastname || '',
                    email: result.data.email,
                    mobileNo: result.data.mobile_no
                }
                
                setSelectedCustomer(newCustomer)
                setShowNewCustomerModal(false)
                
                // Reset shipping address with new customer info
                setShippingAddress({
                    firstname: newCustomer.firstName || result.data.firstname || '',
                    lastname: newCustomer.lastName || result.data.lastname || 'N/A',
                    company: '',
                    house: '',
                    street: '',
                    block: '',
                    area: '',
                    region: 'Chittagong',
                    postcode: '',
                    phone_number: newCustomer.mobileNo || result.data.mobile_no || '',
                    floor_no: '',
                    apartment_no: ''
                })
                
            } else {
                // Handle validation errors
                if (result.errorMessage && typeof result.errorMessage === 'object') {
                    let errorMsg = ''
                    Object.keys(result.errorMessage).forEach(field => {
                        errorMsg += `• ${field}: ${result.errorMessage[field].join(', ')}<br>`
                    })
                    Swal.fire({
                        icon: 'error',
                        title: 'Validation Errors',
                        html: errorMsg,
                        confirmButtonColor: '#d33'
                    })
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: 'Failed to create customer: ' + (result.errorMessage || result.message || 'Unknown error'),
                        confirmButtonColor: '#d33'
                    })
                }
            }
        } catch (error) {
            console.error('Error creating customer:', error)
            Swal.fire({
                icon: 'error',
                title: 'Connection Error',
                text: 'Error creating customer. Please try again.',
                confirmButtonColor: '#d33'
            })
        } finally {
            setLoading(false)
        }
    }

    const submitNewAddress = async () => {
        try {
            setLoading(true)
            
            const response = await fetch(process.env.REACT_APP_API_URL + 'customers_address_create', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    ...getRequestOptions().headers
                },
                body: JSON.stringify(addressForm)
            })
            
            const result = await response.json()
            
            if (result.success) {
                Swal.fire({
                    icon: 'success',
                    title: 'Success!',
                    text: 'Address created successfully!',
                    confirmButtonColor: '#3085d6',
                    timer: 2000,
                    showConfirmButton: false
                })
                
                setShowNewAddressModal(false)
                
                // Refresh customer addresses
                if (selectedCustomer) {
                    handleCustomerSelect(selectedCustomer)
                }
                
            } else {
                // Handle validation errors
                if (result.errorMessage && typeof result.errorMessage === 'object') {
                    let errorMsg = ''
                    Object.keys(result.errorMessage).forEach(field => {
                        errorMsg += `• ${field}: ${result.errorMessage[field].join(', ')}<br>`
                    })
                    Swal.fire({
                        icon: 'error',
                        title: 'Validation Errors',
                        html: errorMsg,
                        confirmButtonColor: '#d33'
                    })
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: 'Failed to create address: ' + (result.errorMessage || result.message || 'Unknown error'),
                        confirmButtonColor: '#d33'
                    })
                }
            }
        } catch (error) {
            console.error('Error creating address:', error)
            Swal.fire({
                icon: 'error',
                title: 'Connection Error',
                text: 'Error creating address. Please try again.',
                confirmButtonColor: '#d33'
            })
        } finally {
            setLoading(false)
        }
    }

    const findCustomerFromBilling = async () => {
        if (!customerForm.ispCustomerId) {
            Swal.fire({
                icon: 'warning',
                title: 'Warning',
                text: 'Please enter an ISP Customer ID',
                confirmButtonColor: '#3085d6'
            })
            return
        }

        try {
            setLoading(true)
            const response = await fetch(`${process.env.REACT_APP_BILL_API_URL}customer_details/${customerForm.ispCustomerId}`)
            const result = await response.json()
            
            if (result && result.id) {
                // Auto-fill the form with billing data
                setCustomerForm(prev => ({
                    ...prev,
                    firstname: result.name || '',
                    email: result.email || '',
                    mobile_no: result.mobileNo || '',
                }))
                
                Swal.fire({
                    icon: 'success',
                    title: 'Customer Found!',
                    text: `Customer details loaded for ID: ${result.id}`,
                    confirmButtonColor: '#3085d6',
                    timer: 2000,
                    showConfirmButton: false
                })
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Customer Not Found',
                    text: 'No customer found with the provided ISP Customer ID',
                    confirmButtonColor: '#d33'
                })
            }
        } catch (error) {
            console.error('Error fetching customer from billing:', error)
            Swal.fire({
                icon: 'error',
                title: 'Connection Error',
                text: 'Error fetching customer details. Please try again.',
                confirmButtonColor: '#d33'
            })
        } finally {
            setLoading(false)
        }
    }

    const calculateOrderTotals = () => {
        let subtotal = 0
        let totalDiscount = 0
        let totalTax = 0

        selectedProducts.forEach(product => {
            // If given price is higher than original price, use given price for subtotal
            const itemSubtotal = product.price > product.regularPrice 
                ? product.price * product.orderQty 
                : product.regularPrice * product.orderQty
            
            // Discount only applies if given price is less than original price
            const itemDiscount = product.price < product.regularPrice 
                ? (product.regularPrice - product.price) * product.orderQty 
                : 0
            
            const itemTax = (product.price * product.orderQty * product.taxPercent) / 100

            subtotal += itemSubtotal
            totalDiscount += itemDiscount
            totalTax += itemTax
        })

        const shippingAmount =   parseFloat(selectedShippingMethod?.fee) || 0
        const grandTotal = subtotal + totalTax + shippingAmount - totalDiscount

        return {
            subtotal,
            totalDiscount,
            totalTax,
            shippingAmount,
            grandTotal
        }
    }

    const validateForm = () => {
        const errors = []

        // Customer validation
        if (!selectedCustomer) {
            errors.push('Please select a customer or create a new one')
        }


        // Products validation
        if (selectedProducts.length === 0) {
            errors.push('At least one product must be selected')
        }

        selectedProducts.forEach((product, index) => {
            if (product.orderQty <= 0) {
                errors.push(`Product ${index + 1}: Quantity must be greater than 0`)
            }
        })

        return errors
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        
        const errors = validateForm()
        if (errors.length > 0) {
            alert('Please fix the following errors:\n' + errors.join('\n'))
            return
        }

        setSubmitting(true)

        try {
            const orderData = {
                accountInfo: {
                    customerId: selectedCustomer.customerId,
                    phoneNumber: selectedCustomer.mobileNo,
                    email: selectedCustomer.email || '',
                    group: selectedCustomer.customerGroupId || '1' // Default to General if not set
                },
                billingAddress: {
                    firstName: shippingAddress.firstname,
                    lastName: shippingAddress.lastname || '',
                    company: shippingAddress.company || '',
                    house: shippingAddress.house,
                    street: shippingAddress.street,
                    block: shippingAddress.block || '',
                    area: shippingAddress.area,
                    region: shippingAddress.region,
                    postcode: shippingAddress.postcode || '',
                    phoneNumber: shippingAddress.phone_number,
                    floorNo: shippingAddress.floor_no || '',
                    apartmentNo: shippingAddress.apartment_no || ''
                },
                shippingAddress: {
                    firstName: shippingAddress.firstname,
                    lastName: shippingAddress.lastname || '',
                    company: shippingAddress.company || '',
                    house: shippingAddress.house,
                    street: shippingAddress.street,
                    block: shippingAddress.block || '',
                    area: shippingAddress.area,
                    region: shippingAddress.region,
                    postcode: shippingAddress.postcode || '',
                    phoneNumber: shippingAddress.phone_number,
                    floorNo: shippingAddress.floor_no || '',
                    apartmentNo: shippingAddress.apartment_no || ''
                },
                shippingMethod: selectedShippingMethod ? {
                    shippingMethodId: selectedShippingMethod.shippingMethodId,
                    fee: selectedShippingMethod.fee
                } : null,
                paymentMethod,
                items: selectedProducts.map(product => ({
                    productId: product.productId,
                    product_name: product.productName,
                    productName: product.productName,
                    sku: product.sku,
                    price: product.price > product.regularPrice ? product.price : product.regularPrice ,
                    orderQty: product.orderQty,
                    discountPercent: product.price < product.regularPrice ? product.discountPercent : 0,
                    discount: product.price < product.regularPrice ? (product.regularPrice - product.price) * product.orderQty : 0,
                    taxPercent: product.taxPercent,
                    tax: product.price > product.regularPrice ? (product.price * product.orderQty * product.taxPercent) / 100 : 0,
                    rowSubtotal: (product.price > product.regularPrice ? product.price : product.regularPrice) * product.orderQty - (product.price < product.regularPrice ? (product.regularPrice - product.price) * product.orderQty : 0),
                    type: product.type
                })),
                emailSent,
                comments
            }

            const response = await OrderService.createOrder(orderData)

            if (response.success) {
                alert('Order created successfully!')
                history.push('/sales-orders')
            } else {
                alert('Failed to create order: ' + (response.errorMessage || response.message))
            }
        } catch (error) {
            console.error('Error creating order:', error)
            alert('Error creating order. Please try again.')
        } finally {
            setSubmitting(false)
        }
    }

    const totals = calculateOrderTotals()

    return (
        <div className="container-fluid">
            {/* Page Header */}
            <div className="d-flex justify-content-between align-items-center mb-4 page-header-mobile">
                <div>
                    <div className="d-flex align-items-center">
                        <Link to="/sales-orders" className="btn btn-link p-0 me-3 btn-mobile">
                            <i className="fas fa-arrow-left"></i>
                        </Link>
                        <div>
                            <h1 className="h3 mb-0">Create New Order</h1>
                            <p className="text-muted mb-0">Fill in the details to create a new order</p>
                        </div>
                    </div>
                </div>
            </div>

            <form onSubmit={handleSubmit}>
                <div className="row">
                    {/* Left Column */}
                    <div className="col-lg-8 col-md-12">
                        {/* Customer Information */}
                        <div className="card mb-4">
                            <div className="card-header card-header-mobile">
                                <h5 className="card-title mb-0">Customer Information</h5>
                            </div>
                            <div className="card-body">
                                    <div>
                                        <div className="mb-3">
                                            <label className="form-label">Search Customer</label>
                                            <input
                                                type="text"
                                                className="form-control form-control-mobile"
                                                placeholder="Search by name, email, or phone..."
                                                value={customerSearch}
                                                onChange={(e) => setCustomerSearch(e.target.value)}
                                            />
                                            {customers.length > 0 && (
                                                <div className="list-group mt-2">
                                                    {customers.map(customer => (
                                                        <button
                                                            key={customer.customerId}
                                                            type="button"
                                                            className="list-group-item list-group-item-action"
                                                            onClick={() => handleCustomerSelect(customer)}
                                                        >
                                                            <div>
                                                                <strong>{customer.customerName}</strong>
                                                                <div className="small text-muted">
                                                                    {customer.email} | {customer.mobileNo}
                                                                </div>
                                                            </div>
                                                        </button>
                                                    ))}
                                                </div>
                                            )}
                                        </div>

                                        {selectedCustomer && (
                                            <div className="alert alert-success">
                                                <strong>Selected Customer:</strong> {selectedCustomer.customerName}<br/>
                                                <small>{selectedCustomer.email} | {selectedCustomer.mobileNo}</small>
                                            </div>
                                        )}

                                        <button
                                            type="button"
                                        className="btn btn-primary btn-mobile"
                                        onClick={openNewCustomerModal}
                                        >
                                        <i className="fas fa-user-plus me-2"></i>Create New Customer
                                        </button>
                                    </div>
                            </div>
                        </div>

                        {/* Shipping Address */}
                        <div className="card mb-4">
                            <div className="card-header card-header-mobile">
                                <div className="d-flex justify-content-between align-items-center">
                                    <h5 className="card-title mb-0">Shipping Address</h5>
                                    <div className="d-flex align-items-center gap-2">
                                        {selectedCustomer && (
                                            <button
                                                type="button"
                                                className="btn btn-outline-primary btn-sm btn-mobile"
                                                onClick={openNewAddressModal}
                                            >
                                                <i className="fas fa-plus me-1"></i>Add Address
                                            </button>
                                        )}
                                    {addressLoading && (
                                        <div className="d-flex align-items-center">
                                            <div className="spinner-border spinner-border-sm text-primary me-2" role="status">
                                                <span className="visually-hidden">Loading address...</span>
                                            </div>
                                            <small className="text-muted">Loading address...</small>
                                        </div>
                                    )}
                                    </div>
                                </div>
                            </div>
                            <div className="card-body">
                                {/* Customer Address Selection (when customer is selected and has addresses) */}
                                {selectedCustomer && customerAddresses.length > 0 && !showAddressList && selectedAddress && (
                                    <div className="customer-address-display">
                                        <div className="d-flex justify-content-between align-items-start mb-3">
                                            <div className="address-info flex-grow-1">
                                                <h6 className="text-primary mb-2">
                                                    <i className="fas fa-map-marker-alt me-2"></i>
                                                    Selected Address
                                                </h6>
                                                {(() => {
                                                    const formatted = formatAddress(selectedAddress);
                                                    return (
                                                        <div>
                                                            <div className="address-line">
                                                                <strong>{formatted.line1}</strong>
                                                            </div>
                                                            {formatted.line2 && (
                                                                <div className="address-line text-muted">
                                                                    {formatted.line2}
                                                                </div>
                                                            )}
                                                            <div className="address-line">
                                                                <strong>{formatted.area}, {formatted.region}</strong>
                                                            </div>
                                                            <div className="address-contact text-muted">
                                                                {formatted.contact}
                                                            </div>
                                                        </div>
                                                    );
                                                })()}
                                            </div>
                                            <button
                                                type="button"
                                                className="btn btn-outline-primary btn-sm"
                                                onClick={changeShowAddressList}
                                            >
                                                <i className="fas fa-edit me-1"></i>
                                                Change
                                            </button>
                                        </div>
                                    </div>
                                )}

                                {/* Address List Selection */}
                                {selectedCustomer && customerAddresses.length > 0 && showAddressList && (
                                    <div className="address-selection">
                                        <h6 className="text-primary mb-3">
                                            <i className="fas fa-list me-2"></i>
                                            Choose an Address
                                        </h6>
                                        <div className="address-list">
                                            {customerAddresses.map((address, index) => {
                                                const formatted = formatAddress(address);
                                                return (
                                                    <div 
                                                        key={address.customerAddressId} 
                                                        className={`address-item ${selectedAddress?.customerAddressId === address.customerAddressId ? 'selected' : ''}`}
                                                        onClick={() => handleAddressSelect(address)}
                                                    >
                                                        <div className="d-flex align-items-start">
                                                            <div className="address-radio me-3">
                                                                <i className={`fas ${selectedAddress?.customerAddressId === address.customerAddressId ? 'fa-dot-circle' : 'fa-circle'} text-primary`}></i>
                                                            </div>
                                                            <div className="address-content flex-grow-1">
                                                                <div className="address-line">
                                                                    <strong>{formatted.line1}</strong>
                                                                </div>
                                                                {formatted.line2 && (
                                                                    <div className="address-line text-muted">
                                                                        {formatted.line2}
                                                                    </div>
                                                                )}
                                                                <div className="address-line">
                                                                    <strong>{formatted.area}, {formatted.region}</strong>
                                                                </div>
                                                                <div className="address-contact text-muted">
                                                                    {formatted.contact}
                                                                </div>
                                                                {address.is_default_shipping && (
                                                                    <div className="default-address-badge">
                                                                        <span className="badge bg-success">Default</span>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>
                                )}

                                {/* No Customer Selected */}
                                        {!selectedCustomer && (
                                            <div className="alert alert-info">
                                                <i className="fas fa-info-circle me-2"></i>
                                        Please select a customer first. You can then choose from their existing addresses or add new addresses.
                                    </div>
                                )}
                            </div>
                        </div>

                        {/* Products */}
                        <div className="card mb-4">
                            <div className="card-header card-header-mobile">
                                <div className="d-flex justify-content-between align-items-center">
                                    <h5 className="card-title mb-0">Order Items</h5>
                                    <button
                                        type="button"
                                        className="btn btn-primary btn-sm btn-mobile"
                                        onClick={() => setShowProductModal(true)}
                                    >
                                        <i className="fas fa-plus me-2"></i>Add Product
                                    </button>
                                </div>
                            </div>
                            <div className="card-body">
                                {selectedProducts.length > 0 ? (
                                    <div className="table-responsive">
                                        <table className="table table-striped table-mobile">
                                            <thead>
                                                <tr>
                                                    <th>Product</th>
                                                    <th>SKU</th>
                                                    <th>Price</th>
                                                    <th>Quantity</th>
                                                    <th>Total</th>
                                                    <th>Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {selectedProducts.map((product) => (
                                                    <tr key={product.productId}>
                                                        <td>
                                                            <div>
                                                                <strong>{product.productName}</strong>
                                                                {product.specialPrice && (
                                                                    <div className="small text-success">
                                                                        Special Price (was {OrderService.formatCurrency(product.regularPrice)})
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </td>
                                                        <td>{product.sku}</td>
                                                        <td>
                                                            <input
                                                                type="number"
                                                                className="form-control form-control-mobile"
                                                                style={{ width: '100px' }}
                                                                min="0"
                                                                step="0.01"
                                                                value={product.price}
                                                                onChange={(e) => updateProductPrice(product.productId, e.target.value)}
                                                            />
                                                            {product.specialPrice && product.price !== product.regularPrice && (
                                                                <small className="text-muted">Original: {OrderService.formatCurrency(product.regularPrice)}</small>
                                                            )}
                                                        </td>
                                                        <td>
                                                            <input
                                                                type="number"
                                                                className="form-control form-control-mobile"
                                                                style={{ width: '80px' }}
                                                                min="1"
                                                                // max={product.availableQty}
                                                                value={product.orderQty}
                                                                onChange={(e) => updateProductQuantity(product.productId, e.target.value)}
                                                            />
                                                            <small className="text-muted">Available: {product.availableQty}</small>
                                                        </td>
                                                        <td>{OrderService.formatCurrency(product.price * product.orderQty)}</td>
                                                        <td>
                                                            <button
                                                                type="button"
                                                                className="btn btn-outline-danger btn-sm btn-mobile"
                                                                onClick={() => removeProduct(product.productId)}
                                                            >
                                                                <i className="fas fa-trash"></i>
                                                            </button>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                ) : (
                                    <div className="text-center py-4 text-muted">
                                        <i className="fas fa-shopping-cart fa-3x mb-3"></i>
                                        <p>No products added yet. Click "Add Product" to get started.</p>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>

                    {/* Right Column */}
                    <div className="col-lg-4 col-md-12">
                        {/* Order Summary */}
                        <div className="card mb-4">
                            <div className="card-header card-header-mobile">
                                <h5 className="card-title mb-0">Order Summary</h5>
                            </div>
                            <div className="card-body">
                                <table className="table table-borderless">
                                    <tbody>
                                        <tr>
                                            <td>Subtotal:</td>
                                            <td className="text-end">{OrderService.formatCurrency(totals.subtotal)}</td>
                                        </tr>
                                        <tr>
                                            <td>Discount:</td>
                                            <td className="text-end text-success">-{OrderService.formatCurrency(totals.totalDiscount)}</td>
                                        </tr>
                                        <tr>
                                            <td>Tax:</td>
                                            <td className="text-end">{OrderService.formatCurrency(totals.totalTax)}</td>
                                        </tr>
                                        <tr>
                                            <td>Shipping:</td>
                                            <td className="text-end">{OrderService.formatCurrency(totals.shippingAmount)}</td>
                                        </tr>
                                        <tr className="border-top">
                                            <th>Grand Total:</th>
                                            <th className="text-end">{OrderService.formatCurrency(totals.grandTotal)}</th>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        {/* Shipping Method */}
                        <div className="card mb-4">
                            <div className="card-header card-header-mobile">
                                <h5 className="card-title mb-0">Shipping Method</h5>
                            </div>
                            <div className="card-body">
                                {shippingMethods.map((method) => (
                                    <div key={method.shippingMethodId} className="form-check">
                                        <input
                                            className="form-check-input"
                                            type="radio"
                                            name="shippingMethod"
                                            id={`shipping-${method.shippingMethodId}`}
                                            checked={selectedShippingMethod?.shippingMethodId === method.shippingMethodId}
                                            onChange={() => setSelectedShippingMethod(method)}
                                        />
                                        <label className="form-check-label" htmlFor={`shipping-${method.shippingMethodId}`}>
                                            <div>
                                                <strong>{method.methodName}</strong>
                                                <div className="small text-muted">{OrderService.formatCurrency(method.fee)}</div>
                                            </div>
                                        </label>
                                    </div>
                                ))}
                            </div>
                        </div>

                        {/* Payment Method */}
                        <div className="card mb-4">
                            <div className="card-header card-header-mobile">
                                <h5 className="card-title mb-0">Payment Method</h5>
                            </div>
                            <div className="card-body">
                                <select
                                    className="form-select form-select-mobile"
                                    value={paymentMethod}
                                    onChange={(e) => setPaymentMethod(e.target.value)}
                                >
                                    <option value="">Select Payment Method</option>
                                    <option value="1">Cash on Delivery</option>
                                    <option value="2">Bank Transfer</option>
                                    <option value="3">Credit Card</option>
                                    <option value="4">Mobile Banking</option>
                                </select>
                            </div>
                        </div>

                        {/* Additional Options */}
                        <div className="card mb-4">
                            <div className="card-header card-header-mobile">
                                <h5 className="card-title mb-0">Additional Options</h5>
                            </div>
                            <div className="card-body">
                                <div className="form-check mb-3">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id="emailSent"
                                        checked={emailSent}
                                        onChange={(e) => setEmailSent(e.target.checked)}
                                    />
                                    <label className="form-check-label" htmlFor="emailSent">
                                        Send order confirmation email
                                    </label>
                                </div>

                                <div className="mb-3">
                                    <label className="form-label">Comments</label>
                                    <textarea
                                        className="form-control form-control-mobile"
                                        rows="3"
                                        value={comments}
                                        onChange={(e) => setComments(e.target.value)}
                                        placeholder="Enter any additional comments..."
                                    ></textarea>
                                </div>
                            </div>
                        </div>

                        {/* Submit Button */}
                        <div className="d-grid">
                            <button
                                type="submit"
                                className="btn btn-primary btn-lg btn-mobile"
                                disabled={submitting || selectedProducts.length === 0}
                            >
                                {submitting ? (
                                    <>
                                        <span className="spinner-border spinner-border-sm me-2"></span>
                                        Creating Order...
                                    </>
                                ) : (
                                    <>
                                        <i className="fas fa-save me-2"></i>
                                        Create Order
                                    </>
                                )}
                            </button>
                        </div>
                    </div>
                </div>
            </form>

            {/* New Customer Modal */}
            {showNewCustomerModal && (
                <div className='modal show modal-adaptive' style={{display: 'block', backgroundColor: 'rgba(0,0,0,0.6)'}} onClick={() => setShowNewCustomerModal(false)}>
                    <div className='modal-dialog modal-dialog-adaptive' onClick={(e) => e.stopPropagation()}>
                        <div className='modal-content customer-modal'>
                            <div className='modal-header border-bottom sticky-top bg-white'>
                                <h4 className='modal-title mb-0'>
                                    <i className='fas fa-user-plus text-primary me-2'></i>
                                    Add New Customer
                                </h4>
                                <button type='button' className='btn-close' onClick={() => setShowNewCustomerModal(false)}></button>
                            </div>
                            <div className='modal-body modal-body-scrollable p-4'>
                                <form onSubmit={(e) => { e.preventDefault(); submitNewCustomer(); }}>
                                    <div className='row g-3'>
                                        {/* ISP Customer ID with Find Button */}
                                        <div className='col-12'>
                                            <div className='isp-customer-field'>
                                                <div className='form-group-mui'>
                                                    <input
                                                        type='text'
                                                        className='form-control form-control-mui'
                                                        id='ispCustomerId'
                                                        value={customerForm.ispCustomerId}
                                                        onChange={(e) => handleCustomerFormChange('ispCustomerId', e.target.value)}
                                                        placeholder=' '
                                                    />
                                                    <label htmlFor='ispCustomerId' className='form-label-mui'>
                                                        <i className='fas fa-id-card text-muted me-2'></i>
                                                        ISP Customer ID
                                                    </label>
                                                </div>
                                                <button
                                                    type='button'
                                                    className='btn btn-sm btn-primary find-btn-small'
                                                    onClick={findCustomerFromBilling}
                                                    disabled={loading || !customerForm.ispCustomerId}
                                                    title="Find Customer"
                                                >
                                                    {loading ? (
                                                        <span className="spinner-border spinner-border-sm" role="status"></span>
                                                    ) : (
                                                        <i className='fas fa-search'></i>
                                                    )}
                                                </button>
                                            </div>
                                        </div>

                                        {/* Name - Full width */}
                                        <div className='col-12'>
                                            <div className='form-group-mui'>
                                                <input
                                                    type='text'
                                                    className='form-control form-control-mui'
                                                    id='firstname'
                                                    value={customerForm.firstname}
                                                    onChange={(e) => handleCustomerFormChange('firstname', e.target.value)}
                                                    placeholder=' '
                                                    required
                                                />
                                                <label htmlFor='firstname' className='form-label-mui'>
                                                    <i className='fas fa-user text-muted me-2'></i>
                                                    Name *
                                                </label>
                                            </div>
                                        </div>

                                        {/* Email and Mobile */}
                                        <div className='col-md-6'>
                                            <div className='form-group-mui'>
                                                <input
                                                    type='email'
                                                    className='form-control form-control-mui'
                                                    id='email'
                                                    value={customerForm.email}
                                                    onChange={(e) => handleCustomerFormChange('email', e.target.value)}
                                                    placeholder=' '
                                                    required
                                                />
                                                <label htmlFor='email' className='form-label-mui'>
                                                    <i className='fas fa-envelope text-muted me-2'></i>
                                                    Email *
                                                </label>
                                            </div>
                                        </div>

                                        <div className='col-md-6'>
                                            <div className='form-group-mui'>
                                                <input
                                                    type='text'
                                                    className='form-control form-control-mui'
                                                    id='mobile_no'
                                                    value={customerForm.mobile_no}
                                                    onChange={(e) => handleCustomerFormChange('mobile_no', e.target.value)}
                                                    placeholder=' '
                                                    required
                                                />
                                                <label htmlFor='mobile_no' className='form-label-mui'>
                                                    <i className='fas fa-phone text-muted me-2'></i>
                                                    Mobile Number *
                                                </label>
                                            </div>
                                        </div>

                                        {/* Gender and Date of Birth */}
                                        <div className='col-md-6'>
                                            <div className='form-group-mui'>
                                                <select
                                                    className='form-control form-control-mui'
                                                    id='gender'
                                                    value={customerForm.gender}
                                                    onChange={(e) => handleCustomerFormChange('gender', e.target.value)}
                                                    style={{ 
                                                        appearance: 'none',
                                                        backgroundImage: 'url("data:image/svg+xml,%3csvg xmlns=\'http://www.w3.org/2000/svg\' fill=\'none\' viewBox=\'0 0 20 20\'%3e%3cpath stroke=\'%236b7280\' stroke-linecap=\'round\' stroke-linejoin=\'round\' stroke-width=\'1.5\' d=\'m6 8 4 4 4-4\'/%3e%3c/svg%3e")',
                                                        backgroundPosition: 'right 0.5rem center',
                                                        backgroundRepeat: 'no-repeat',
                                                        backgroundSize: '1.5em 1.5em',
                                                        paddingRight: '2.5rem'
                                                    }}
                                                >
                                                    <option value=''>Select Gender</option>
                                                    <option value='male'>Male</option>
                                                    <option value='female'>Female</option>
                                                    <option value='other'>Other</option>
                                                </select>
                                                <label htmlFor='gender' className='form-label-mui'>
                                                    <i className='fas fa-venus-mars text-muted me-2'></i>
                                                    Gender
                                                </label>
                                            </div>
                                        </div>

                                        <div className='col-md-6'>
                                            <div className='form-group-mui'>
                                                <input
                                                    type='date'
                                                    className='form-control form-control-mui'
                                                    id='dob'
                                                    value={customerForm.dob}
                                                    onChange={(e) => handleCustomerFormChange('dob', e.target.value)}
                                                    placeholder=' '
                                                />
                                                <label htmlFor='dob' className='form-label-mui'>
                                                    <i className='fas fa-calendar text-muted me-2'></i>
                                                    Date of Birth
                                                </label>
                                            </div>
                                        </div>

                                        {/* Password */}
                                        <div className='col-md-6'>
                                            <div className='form-group-mui'>
                                                <input
                                                    type='number'
                                                    className='form-control form-control-mui'
                                                    id='password'
                                                    value={customerForm.password}
                                                    onChange={(e) => handleCustomerFormChange('password', e.target.value)}
                                                    placeholder=' '
                                                />
                                                <label htmlFor='password' className='form-label-mui'>
                                                    <i className='fas fa-lock text-muted me-2'></i>
                                                    4 Digit PIN
                                                </label>
                                            </div>
                                        </div>

                                        {/* Active Status */}
                                        <div className='col-md-6 d-flex align-items-center'>
                                            <div className='form-check form-check-modern'>
                                                <input
                                                    className='form-check-input'
                                                    type='checkbox'
                                                    id='is_active'
                                                    checked={customerForm.is_active}
                                                    onChange={(e) => handleCustomerFormChange('is_active', e.target.checked)}
                                                />
                                                <label className='form-check-label' htmlFor='is_active'>
                                                    <i className='fas fa-toggle-on text-success me-2'></i>
                                                    Active Customer
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                            <div className='modal-footer customer-modal-footer bg-white border-top sticky-bottom'>
                                <button type='button' className='btn btn-outline-secondary' onClick={() => setShowNewCustomerModal(false)}>
                                    <i className='fas fa-times me-2'></i>
                                    Cancel
                                </button>
                                <button type='button' className='btn btn-primary btn-modern' onClick={submitNewCustomer} disabled={loading}>
                                    {loading ? (
                                        <>
                                            <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                                            Creating...
                                        </>
                                    ) : (
                                        <>
                                            <i className='fas fa-save me-2'></i>
                                            Create Customer
                                        </>
                                    )}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* New Address Modal */}
            {showNewAddressModal && (
                <div className='modal show modal-adaptive' style={{display: 'block', backgroundColor: 'rgba(0,0,0,0.6)'}} onClick={() => setShowNewAddressModal(false)}>
                    <div className='modal-dialog modal-dialog-adaptive' onClick={(e) => e.stopPropagation()}>
                        <div className='modal-content address-modal'>
                            <div className='modal-header border-bottom sticky-top bg-white'>
                                <h4 className='modal-title mb-0'>
                                    <i className='fas fa-map-marker-alt text-primary me-2'></i>
                                    Add Address for {selectedCustomer?.customerName}
                                </h4>
                                <button type='button' className='btn-close' onClick={() => setShowNewAddressModal(false)}></button>
                            </div>
                            <div className='modal-body modal-body-scrollable p-4'>
                                <form onSubmit={(e) => { e.preventDefault(); submitNewAddress(); }}>
                                    <div className='row g-3'>
                                        {/* Area - Full width at top */}
                                        <div className='col-12'>
                                            <div className='form-group-mui'>
                                                <select
                                                    className='form-control form-control-mui'
                                                    id='area'
                                                    value={addressForm.area}
                                                    onChange={(e) => handleAddressFormChange('area', e.target.value)}
                                                    style={{ 
                                                        appearance: 'none',
                                                        backgroundImage: 'url("data:image/svg+xml,%3csvg xmlns=\'http://www.w3.org/2000/svg\' fill=\'none\' viewBox=\'0 0 20 20\'%3e%3cpath stroke=\'%236b7280\' stroke-linecap=\'round\' stroke-linejoin=\'round\' stroke-width=\'1.5\' d=\'m6 8 4 4 4-4\'/%3e%3c/svg%3e")',
                                                        backgroundPosition: 'right 0.5rem center',
                                                        backgroundRepeat: 'no-repeat',
                                                        backgroundSize: '1.5em 1.5em',
                                                        paddingRight: '2.5rem'
                                                    }}
                                                >
                                                    <option value=''>Select Area</option>
                                                    {areas.map((option, key) => (
                                                        <option key={key} value={option.value}>
                                                            {option.label}
                                                        </option>
                                                    ))}
                                                </select>
                                                <label htmlFor='area' className='form-label-mui'>
                                                    <i className='fas fa-map-marked-alt text-muted me-2'></i>
                                                    Area
                                                </label>
                                            </div>
                                        </div>

                                        {/* House No and Floor No */}
                                        <div className='col-6'>
                                            <div className='form-group-mui'>
                                                <input
                                                    type='text'
                                                    className='form-control form-control-mui'
                                                    id='house'
                                                    value={addressForm.house}
                                                    onChange={(e) => handleAddressFormChange('house', e.target.value)}
                                                    placeholder=' '
                                                    required
                                                />
                                                <label htmlFor='house' className='form-label-mui'>
                                                    <i className='fas fa-home text-muted me-2'></i>
                                                    House no *
                                                </label>
                                            </div>
                                        </div>

                                        <div className='col-6'>
                                            <div className='form-group-mui'>
                                                <input
                                                    type='text'
                                                    className='form-control form-control-mui'
                                                    id='floor_no'
                                                    value={addressForm.floor_no}
                                                    onChange={(e) => handleAddressFormChange('floor_no', e.target.value)}
                                                    placeholder=' '
                                                />
                                                <label htmlFor='floor_no' className='form-label-mui'>
                                                    <i className='fas fa-layer-group text-muted me-2'></i>
                                                    Floor No
                                                </label>
                                            </div>
                                        </div>

                                        {/* Block/Sector and Flat No */}
                                        <div className='col-6'>
                                            <div className='form-group-mui'>
                                                <input
                                                    type='text'
                                                    className='form-control form-control-mui'
                                                    id='block'
                                                    value={addressForm.block}
                                                    onChange={(e) => handleAddressFormChange('block', e.target.value)}
                                                    placeholder=' '
                                                />
                                                <label htmlFor='block' className='form-label-mui'>
                                                    <i className='fas fa-building text-muted me-2'></i>
                                                    Block/Sector
                                                </label>
                                            </div>
                                        </div>

                                        <div className='col-6'>
                                            <div className='form-group-mui'>
                                                <input
                                                    type='text'
                                                    className='form-control form-control-mui'
                                                    id='apartment_no'
                                                    value={addressForm.apartment_no}
                                                    onChange={(e) => handleAddressFormChange('apartment_no', e.target.value)}
                                                    placeholder=' '
                                                />
                                                <label htmlFor='apartment_no' className='form-label-mui'>
                                                    <i className='fas fa-door-open text-muted me-2'></i>
                                                    Flat No
                                                </label>
                                            </div>
                                        </div>

                                        {/* Road/Street - Full width */}
                                        <div className='col-12'>
                                            <div className='form-group-mui'>
                                                <input
                                                    type='text'
                                                    className='form-control form-control-mui'
                                                    id='street'
                                                    value={addressForm.street}
                                                    onChange={(e) => handleAddressFormChange('street', e.target.value)}
                                                    placeholder=' '
                                                    required
                                                />
                                                <label htmlFor='street' className='form-label-mui'>
                                                    <i className='fas fa-road text-muted me-2'></i>
                                                    Road/Street *
                                                </label>
                                            </div>
                                        </div>

                                        {/* Region - Hidden but set default */}
                                        <div className='col-12' style={{display: 'none'}}>
                                            <div className='form-group-mui'>
                                                <input
                                                    type='text'
                                                    className='form-control form-control-mui'
                                                    id='region'
                                                    value={addressForm.region || 'Chittagong'}
                                                    onChange={(e) => handleAddressFormChange('region', e.target.value)}
                                                />
                                            </div>
                                        </div>

                                        {/* Name */}
                                        <div className='col-12'>
                                            <div className='form-group-mui'>
                                                <input
                                                    type='text'
                                                    className='form-control form-control-mui'
                                                    id='firstname'
                                                    value={addressForm.firstname}
                                                    onChange={(e) => handleAddressFormChange('firstname', e.target.value)}
                                                    placeholder=' '
                                                    required
                                                />
                                                <label htmlFor='firstname' className='form-label-mui'>
                                                    <i className='fas fa-user text-muted me-2'></i>
                                                    Name *
                                                </label>
                                            </div>
                                        </div>

                                        {/* Phone Number */}
                                        <div className='col-12'>
                                            <div className='form-group-mui'>
                                                <input
                                                    type='text'
                                                    className='form-control form-control-mui'
                                                    id='phone_number'
                                                    value={addressForm.phone_number}
                                                    onChange={(e) => handleAddressFormChange('phone_number', e.target.value)}
                                                    placeholder=' '
                                                    required
                                                />
                                                <label htmlFor='phone_number' className='form-label-mui'>
                                                    <i className='fas fa-phone text-muted me-2'></i>
                                                    Phone Number *
                                                </label>
                                            </div>
                                        </div>

                                        {/* Default Address Checkbox */}
                                        <div className='col-12'>
                                            <div className='address-options'>
                                                <div className='form-check form-check-modern'>
                                                    <input
                                                        className='form-check-input'
                                                        type='checkbox'
                                                        id='defaultShipping'
                                                        checked={addressForm.is_default_shipping}
                                                        onChange={(e) => handleAddressFormChange('is_default_shipping', e.target.checked)}
                                                    />
                                                    <label className='form-check-label' htmlFor='defaultShipping'>
                                                        <i className='fas fa-shipping-fast text-success me-2'></i>
                                                        Set as Default Shipping Address
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                            <div className='modal-footer address-modal-footer bg-white border-top sticky-bottom'>
                                <button type='button' className='btn btn-outline-secondary' onClick={() => setShowNewAddressModal(false)}>
                                    <i className='fas fa-times me-2'></i>
                                    Cancel
                                </button>
                                <button type='button' className='btn btn-primary btn-modern' onClick={submitNewAddress} disabled={loading}>
                                    {loading ? (
                                        <>
                                            <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                                            Creating...
                                        </>
                                    ) : (
                                        <>
                                            <i className='fas fa-save me-2'></i>
                                            Save Address
                                        </>
                                    )}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Product Selection Modal */}
            {showProductModal && (
                <div className="modal d-block modal-mobile" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                    <div className="modal-dialog modal-lg modal-dialog-mobile">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Select Products</h5>
                                <button 
                                    type="button" 
                                    className="btn-close" 
                                    onClick={() => setShowProductModal(false)}
                                ></button>
                            </div>
                            <div className="modal-body">
                                <div className="mb-3">
                                            <input
                                                type="text"
                                                className="form-control form-control-mobile"
                                        placeholder="Start typing to search products... (minimum 2 characters)"
                                                value={productSearch}
                                                onChange={(e) => setProductSearch(e.target.value)}
                                    />
                                    {productSearch && productSearch.length < 2 && (
                                        <small className="text-muted">Please enter at least 2 characters to search</small>
                                    )}
                                </div>

                                {products.length > 0 ? (
                                    <div className="table-responsive">
                                        <table className="table table-hover table-mobile">
                                            <thead>
                                                <tr>
                                                    <th>Product</th>
                                                    <th>SKU</th>
                                                    <th>Price</th>
                                                    <th>Stock</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {products.map((product) => (
                                                    <tr key={product.product_id}>
                                                        <td>
                                                            <div>
                                                                <strong>{product.product_name}</strong>
                                                                {product.special_price && (
                                                                    <div className="small text-success">
                                                                        Special: {OrderService.formatCurrency(product.special_price)}
                                                                        <span className="text-muted ms-2">
                                                                            (was {OrderService.formatCurrency(product.price)})
                                                                        </span>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </td>
                                                        <td>{product.sku}</td>
                                                        <td>{OrderService.formatCurrency(product.special_price || product.price)}</td>
                                                        <td>{product.qty || 0}</td>
                                                        <td>
                                                            <button
                                                                type="button"
                                                                className="btn btn-primary btn-sm btn-mobile"
                                                                onClick={() => handleProductSelect(product)}
                                                            >
                                                                Add
                                                            </button>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                ) : (
                                    <div className="text-center py-4 text-muted">
                                        {!productSearch ? (
                                            <p>Start typing to search for products...</p>
                                        ) : productSearch.length < 2 ? (
                                            <p>Please enter at least 2 characters to search</p>
                                        ) : (
                                            <p>No products found matching your search</p>
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            )}

            <style jsx>{`
                /* Mobile Responsive Styles */
                .card-header-mobile {
                    padding: 1rem;
                    background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
                    border-bottom: 1px solid #e9ecef;
                }

                .form-control-mobile,
                .form-select-mobile {
                    min-height: 2.5rem;
                    font-size: 0.875rem;
                    border-radius: 0.375rem;
                    border: 1px solid #d1d5db;
                    transition: all 0.2s ease;
                }

                .form-control-mobile:focus,
                .form-select-mobile:focus {
                    border-color: #3b82f6;
                    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
                }

                .btn-mobile {
                    min-height: 2.5rem;
                    font-size: 0.875rem;
                    border-radius: 0.375rem;
                    padding: 0.5rem 1rem;
                    transition: all 0.2s ease;
                }

                .btn-mobile:hover {
                    transform: translateY(-1px);
                    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
                }

                .table-mobile {
                    font-size: 0.875rem;
                }

                .table-mobile th,
                .table-mobile td {
                    padding: 0.5rem;
                    vertical-align: middle;
                }

                .modal-mobile {
                    padding: 1rem;
                }

                .modal-dialog-mobile {
                    margin: 0.5rem auto;
                    max-width: 95%;
                }

                /* Material-UI Style Floating Labels */
                .form-group-mui {
                    position: relative;
                    margin-bottom: 1.5rem;
                    width: 100%;
                }

                .form-control-mui {
                    border: 1px solid #d1d5db;
                    border-radius: 6px;
                    padding: 1rem 1rem 0.5rem 1rem;
                    font-size: 14px;
                    transition: all 0.2s ease;
                    background-color: white;
                    position: relative;
                    z-index: 1;
                    width: 100%;
                    box-sizing: border-box;
                    outline: none;
                    -webkit-font-smoothing: antialiased;
                    -moz-osx-font-smoothing: grayscale;
                    text-rendering: optimizeLegibility;
                    color: #374151;
                    line-height: 1.5;
                }

                .form-control-mui:focus {
                    border-color: #3b82f6;
                    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
                    background-color: white;
                    outline: none;
                }

                .form-control-mui:hover {
                    border-color: #9ca3af;
                }

                .form-label-mui {
                    position: absolute;
                    top: 50%;
                    left: 1rem;
                    transform: translateY(-50%);
                    color: #6b7280;
                    font-size: 14px;
                    font-weight: 400;
                    pointer-events: none;
                    transition: all 0.2s ease;
                    background-color: white;
                    padding: 0 0.25rem;
                    z-index: 2;
                    white-space: nowrap;
                    -webkit-font-smoothing: antialiased;
                    -moz-osx-font-smoothing: grayscale;
                    text-rendering: optimizeLegibility;
                }

                /* Floating label animation */
                .form-control-mui:focus ~ .form-label-mui,
                .form-control-mui:not(:placeholder-shown) ~ .form-label-mui {
                    top: -0.5rem;
                    left: 0.75rem;
                    transform: scale(0.8);
                    color: #3b82f6;
                    font-weight: 500;
                    background-color: white;
                    padding: 0 0.5rem;
                }

                /* Special handling for select dropdowns */
                .form-control-mui option:first-child {
                    display: none;
                }

                .form-control-mui:valid ~ .form-label-mui,
                .form-control-mui[value]:not([value=""]) ~ .form-label-mui {
                    top: -0.5rem;
                    left: 0.75rem;
                    transform: scale(0.8);
                    color: #3b82f6;
                    font-weight: 500;
                    background-color: white;
                    padding: 0 0.5rem;
                }

                /* Mobile responsive adjustments */
                @media (max-width: 768px) {
                    .form-control-mui {
                        font-size: 13px;
                        min-height: 2.5rem;
                    }

                    .form-label-mui {
                        font-size: 13px;
                    }

                    .card-header-mobile {
                        padding: 0.75rem;
                    }

                    .btn-mobile {
                        min-height: 2.25rem;
                        font-size: 0.8rem;
                        padding: 0.375rem 0.75rem;
                    }

                    .table-mobile {
                        font-size: 0.8rem;
                    }

                    .table-mobile th,
                    .table-mobile td {
                        padding: 0.375rem;
                    }

                    .modal-dialog-mobile {
                        margin: 0.25rem auto;
                        max-width: 98%;
                    }
                }

                @media (max-width: 576px) {
                    .form-control-mui {
                        font-size: 12px;
                        min-height: 2.25rem;
                    }

                    .form-label-mui {
                        font-size: 12px;
                    }

                    .card-header-mobile {
                        padding: 0.5rem;
                    }

                    .btn-mobile {
                        min-height: 2rem;
                        font-size: 0.75rem;
                        padding: 0.25rem 0.5rem;
                    }

                    .table-mobile {
                        font-size: 0.75rem;
                    }

                    .table-mobile th,
                    .table-mobile td {
                        padding: 0.25rem;
                    }

                    .modal-dialog-mobile {
                        margin: 0.125rem auto;
                        max-width: 100%;
                    }

                    /* Stack form elements vertically on very small screens */
                    .col-12.col-sm-6 {
                        flex: 0 0 100%;
                        max-width: 100%;
                    }
                }

                /* Additional mobile optimizations */
                @media (max-width: 480px) {
                    .container-fluid {
                        padding-left: 0.5rem;
                        padding-right: 0.5rem;
                    }

                    .card {
                        margin-bottom: 1rem;
                        border-radius: 0.5rem;
                    }

                    .card-body {
                        padding: 0.75rem;
                    }

                    .form-group-mui {
                        margin-bottom: 1rem;
                    }

                    .btn-lg {
                        padding: 0.75rem 1.5rem;
                        font-size: 0.9rem;
                    }
                }

                /* Modal Styles */
                .modal-adaptive {
                    display: flex !important;
                    align-items: center !important;
                    justify-content: center !important;
                    padding: 1rem;
                }

                .modal-dialog-adaptive {
                    max-width: 600px;
                    width: 100%;
                    margin: 0;
                }

                .customer-modal .modal-dialog,
                .address-modal .modal-dialog {
                    max-width: 600px;
                }

                .modal-body-scrollable {
                    max-height: 60vh;
                    overflow-y: auto;
                }

                .sticky-top {
                    position: sticky;
                    top: 0;
                    z-index: 1020;
                }

                .sticky-bottom {
                    position: sticky;
                    bottom: 0;
                    z-index: 1020;
                }

                .customer-modal-footer,
                .address-modal-footer {
                    border-top: 1px solid #dee2e6;
                    padding: 1rem;
                }

                .btn-modern {
                    border-radius: 0.5rem;
                    padding: 0.5rem 1.5rem;
                    font-weight: 500;
                    transition: all 0.2s ease;
                }

                .btn-modern:hover {
                    transform: translateY(-1px);
                    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
                }

                /* Form Check Modern */
                .form-check-modern {
                    padding: 0.75rem;
                    background-color: #f8f9fa;
                    border-radius: 0.5rem;
                    border: 1px solid #e9ecef;
                    transition: all 0.2s ease;
                }

                .form-check-modern:hover {
                    background-color: #e9ecef;
                    border-color: #007bff;
                }

                .form-check-modern .form-check-input:checked ~ .form-check-label {
                    color: #007bff;
                    font-weight: 500;
                }

                /* ISP Customer Field with Find Button */
                .isp-customer-field {
                    display: flex;
                    align-items: flex-end;
                    gap: 0.75rem;
                    width: 100%;
                }

                .isp-customer-field .form-group-mui {
                    flex: 1;
                }

                .find-btn-small {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    min-width: 3.25rem;
                    height: 3.25rem;
                    padding: 0.5rem;
                    border-radius: 6px;
                    background-color: #3b82f6;
                    border-color: #3b82f6;
                    color: white;
                    font-size: 0.875rem;
                    transition: all 0.2s ease;
                    flex-shrink: 0;
                    margin-bottom: 1.5rem;
                }

                .find-btn-small:hover:not(:disabled) {
                    background-color: #2563eb;
                    border-color: #2563eb;
                    transform: translateY(-1px);
                    box-shadow: 0 4px 8px rgba(59, 130, 246, 0.3);
                }

                .find-btn-small:disabled {
                    background-color: #9ca3af;
                    border-color: #9ca3af;
                    cursor: not-allowed;
                    opacity: 0.6;
                    transform: none;
                }

                .find-btn-small i {
                    font-size: 0.875rem;
                }

                /* Address Options */
                .address-options {
                    margin-top: 1rem;
                }

                /* Responsive Modal Adjustments */
                @media (max-width: 768px) {
                    .modal-adaptive {
                        padding: 0.5rem;
                    }

                    .modal-dialog-adaptive {
                        max-width: 100%;
                    }

                    .modal-body-scrollable {
                        max-height: 70vh;
                        padding: 1rem;
                    }

                    .customer-modal-footer,
                    .address-modal-footer {
                        padding: 0.75rem;
                    }

                    .isp-customer-field {
                        gap: 0.5rem;
                    }

                    .find-btn-small {
                        min-width: 3rem;
                        height: 3rem;
                        padding: 0.375rem;
                        font-size: 0.8rem;
                    }

                    .find-btn-small i {
                        font-size: 0.8rem;
                    }
                }

                @media (max-width: 576px) {
                    .modal-adaptive {
                        padding: 0.25rem;
                    }

                    .modal-body-scrollable {
                        max-height: 75vh;
                        padding: 0.75rem;
                    }

                    .customer-modal-footer,
                    .address-modal-footer {
                        padding: 0.5rem;
                        flex-direction: column;
                        gap: 0.5rem;
                    }

                    .customer-modal-footer .btn,
                    .address-modal-footer .btn {
                        width: 100%;
                    }

                    .isp-customer-field {
                        gap: 0.375rem;
                    }

                    .find-btn-small {
                        min-width: 2.75rem;
                        height: 2.75rem;
                        padding: 0.25rem;
                        font-size: 0.75rem;
                    }

                    .find-btn-small i {
                        font-size: 0.75rem;
                    }

                    /* Stack form elements vertically on very small screens */
                    .col-md-6 {
                        flex: 0 0 100%;
                        max-width: 100%;
                    }

                    .col-6 {
                        flex: 0 0 100%;
                        max-width: 100%;
                    }
                }

                /* Address Selection Styles */
                .customer-address-display {
                    background: #f8f9fa;
                    border-radius: 0.5rem;
                    padding: 1rem;
                    border: 1px solid #e9ecef;
                }

                .address-info .address-line {
                    margin-bottom: 0.25rem;
                }

                .address-contact {
                    font-size: 0.875rem;
                    margin-top: 0.5rem;
                }

                .address-selection {
                    max-height: 400px;
                    overflow-y: auto;
                }

                .address-list {
                    display: flex;
                    flex-direction: column;
                    gap: 0.75rem;
                }

                .address-item {
                    border: 1px solid #e9ecef;
                    border-radius: 0.5rem;
                    padding: 1rem;
                    cursor: pointer;
                    transition: all 0.2s ease;
                    background: white;
                }

                .address-item:hover {
                    border-color: #007bff;
                    box-shadow: 0 2px 8px rgba(0, 123, 255, 0.1);
                    transform: translateY(-1px);
                }

                .address-item.selected {
                    border-color: #007bff;
                    background: #f8f9ff;
                    box-shadow: 0 2px 8px rgba(0, 123, 255, 0.15);
                }

                .address-radio {
                    padding-top: 0.125rem;
                }

                .address-content .address-line {
                    margin-bottom: 0.25rem;
                    line-height: 1.4;
                }

                .address-content .address-contact {
                    font-size: 0.875rem;
                    margin-top: 0.5rem;
                }

                .default-address-badge {
                    margin-top: 0.5rem;
                }

                /* Mobile responsive for address selection */
                @media (max-width: 768px) {
                    .customer-address-display {
                        padding: 0.75rem;
                    }

                    .address-item {
                        padding: 0.75rem;
                    }

                    .address-content .address-line {
                        font-size: 0.875rem;
                    }

                    .address-content .address-contact {
                        font-size: 0.8rem;
                    }

                    .address-selection {
                        max-height: 300px;
                    }
                }

                @media (max-width: 576px) {
                    .customer-address-display {
                        padding: 0.5rem;
                    }

                    .address-item {
                        padding: 0.5rem;
                    }

                    .address-list {
                        gap: 0.5rem;
                    }

                    .address-content .address-line {
                        font-size: 0.8rem;
                        margin-bottom: 0.125rem;
                    }

                    .address-content .address-contact {
                        font-size: 0.75rem;
                    }

                    .d-flex.justify-content-between {
                        flex-direction: column;
                        gap: 0.75rem;
                    }

                    .btn-outline-primary.btn-sm {
                        width: 100%;
                        justify-content: center;
                    }
                }
            `}</style>
        </div>
    )
}

export default OrderCreate 